// DeleteConfirmDialog.jsx
import { useEffect } from "react";
import { colors, space, radius } from "../../design/tokens";

export function DeleteConfirmDialog({ entryName, onConfirm, onCancel }) {
  // Close on Escape key
  useEffect(() => {
    const handler = (e) => e.key === "Escape" && onCancel();
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [onCancel]);

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="delete-dialog-title"
      onClick={onCancel} // tap scrim to dismiss
      style={{
        position: "fixed", inset: 0,
        background: "rgba(0,0,0,0.4)",
        display: "flex", alignItems: "flex-end", // sheet from bottom on mobile
        justifyContent: "center",
        zIndex: 999,
        padding: "0 0 env(safe-area-inset-bottom)",
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
        background: colors.surface,
        borderTopLeftRadius: radius.xl,
        borderTopRightRadius: radius.xl,
        padding: space.lg,
          width: "100%",
          maxWidth: "480px",
          textAlign: "center",
        }}
      >
        {/* Drag handle */}

        <p style={{ margin: "0 0 24px", fontSize: 14, color: "#64748b" }}>
          {entryName
            ? <>This will delete <strong>{entryName}</strong></>
            : "This will delete the entry"
          }
        </p>

        <div style={{ display: "flex", gap: 10 }}>
          <button
            onClick={onCancel}
            style={{
              flex: 1, padding: "12px 0", borderRadius: 10, border: "none",
              background: "#f1f5f9", color: "#334155",
              fontSize: 15, fontWeight: 500, cursor: "pointer",
            }}
          >
            Keep it
          </button>
          <button
            onClick={onConfirm}
            autoFocus
            style={{
              flex: 1, padding: "12px 0", borderRadius: 10, border: "none",
              background: "#ef4444", color: "#fff",
              fontSize: 15, fontWeight: 600, cursor: "pointer",
            }}
          >
            Remove
          </button>
        </div>
      </div>
    </div>
  );
}